export default __webpack_public_path__ + "static/media/new-icon-assessment.3ad783a3.svg";